module.exports = __webpack_public_path__ + "img/193-norfolk-island.f5c3f9dc.svg";